import { jsx as m } from "react/jsx-runtime";
import { _ as n } from "../../cs-Dfox81s-.js";
import "../../type-Dku6Xzl6.js";
import '../../index37.css';const _ = "_label_1saq5_1", c = "_strong_1saq5_2", x = "_with-uppercase-letters_1saq5_6", p = "_text-size-small_1saq5_10", z = "_text-size-medium_1saq5_14", S = "_text-size-large_1saq5_18", e = {
  label: _,
  strong: c,
  withUppercaseLetters: x,
  textSizeSmall: p,
  textSizeMedium: z,
  textSizeLarge: S
}, g = {
  sm: e.textSizeSmall,
  md: e.textSizeMedium,
  lg: e.textSizeLarge
};
function f(s) {
  const {
    children: t,
    elementRef: a,
    className: r,
    strong: i,
    textSize: l = "md",
    withUppercaseLetters: o
  } = s;
  return t ? /* @__PURE__ */ m(
    "div",
    {
      ref: a,
      className: n(
        e.label,
        i && e.strong,
        g[l],
        o && e.withUppercaseLetters,
        r
      ),
      children: t
    }
  ) : null;
}
export {
  f as default
};
